import { render, staticRenderFns } from "./AppIsFetching.vue?vue&type=template&id=458e19b3&"
import script from "./AppIsFetching.vue?vue&type=script&lang=js&"
export * from "./AppIsFetching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('458e19b3')) {
      api.createRecord('458e19b3', component.options)
    } else {
      api.reload('458e19b3', component.options)
    }
    module.hot.accept("./AppIsFetching.vue?vue&type=template&id=458e19b3&", function () {
      api.rerender('458e19b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppIsFetching.vue"
export default component.exports